@if (engineOptions().length > 0) {
  <div class="engine-picker" data-testid="engine-picker">
    <label class="engine-picker__label" for="conversion-engine-select">
      Conversion engine
    </label>

    <p-select
      inputId="conversion-engine-select"
      styleClass="engine-picker__select"
      [options]="engineOptions()"
      [ngModel]="selectedEngine()"
      optionLabel="label"
      optionValue="value"
      [disabled]="disabled()"
      appendTo="body"
      (ngModelChange)="onSelectionChange($event)"
    >
      <ng-template let-option pTemplate="item">
        <div class="engine-picker__option">
          <span class="engine-picker__option-label">{{ option.label }}</span>
          @if (option.description) {
            <span class="engine-picker__option-description">{{ option.description }}</span>
          }
        </div>
      </ng-template>
    </p-select>

    @if (lastUsedLabel()) {
      <small class="engine-picker__hint" data-testid="engine-last-used">
        Last used: {{ lastUsedLabel() }}
      </small>
    }
  </div>
}
